import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Button } from "antd";
import useAuth from "app/hooks/useAuth";
import dayjs from "dayjs";
import "dayjs/locale/id";
import { useState } from "react";

const formatTime = (date) => {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}.${minutes}`;
};

export function ScheduleCalendar({ scheduleUIProps }) {
    const {
        data,
        goToSettingSchedule,
        goToCancelSchedule,
        goToCustomerDetail,
        goToRemoveSchedule,
    } = scheduleUIProps;

    dayjs.locale("id");

    const [showPopup, setShowPopup] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const { isStrictAccess, authData } = useAuth();

    const events = data
        ? data.map((item) => ({
              id: item.id,
              title: item.tersedia ? "Tersedia" : "Telah Dipesan",
              start: new Date(item.waktu_booking),
              tersedia: item.tersedia,
              scheduleData: item,
          }))
        : [];

    const renderEventContent = ({ event }) => {
        return (
            <div
                className={`eventContent ${
                    event.extendedProps.tersedia ? "" : "booked"
                }`}
            >
                <div className="event-time">{formatTime(event.start)}</div>
                <div className="event-title">{event.title}</div>
            </div>
        );
    };

    return (
        <div>
            <FullCalendar
                id="fullCalendar"
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
                locale="id"
                initialView="dayGridMonth"
                editable={true}
                selectable={true}
                selectMirror={true}
                dayMaxEvents={true}
                weekends={true}
                events={events}
                eventClick={({ event }) => {
                    setSelectedEvent(event);
                    setShowPopup(true);
                }}
                eventAllow={false}
                eventContent={renderEventContent}
                eventTimeFormat={{
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                }}
                buttonText={{
                    today: "Hari Ini",
                    month: "Bulan",
                    week: "Minggu",
                    day: "Hari",
                }}
            />
            <Dialog
                open={showPopup}
                onClose={() => setShowPopup(false)}
                aria-labelledby="popup-title"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="popup-title">
                    {selectedEvent &&
                        (selectedEvent.extendedProps.tersedia === true
                            ? "Tersedia"
                            : "Telah dipesan")}
                </DialogTitle>
                <DialogContent>
                    {selectedEvent && (
                        <div style={{ fontSize: "14px" }}>
                            <p>
                                Waktu:{" "}
                                {dayjs(selectedEvent.start).format(
                                    "dddd, D MMMM HH:mm"
                                )}
                            </p>
                            {selectedEvent.extendedProps.scheduleData?.pelanggan
                                ?.id !== 0 && (
                                <p>
                                    Nama Pemesan:{" "}
                                    {
                                        selectedEvent.extendedProps.scheduleData
                                            ?.pelanggan?.nama_pelanggan
                                    }
                                </p>
                            )}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignContent: "center",
                                }}
                            >
                                {selectedEvent.extendedProps.tersedia && (
                                    <Button
                                        onClick={() =>
                                            goToSettingSchedule(
                                                selectedEvent.id
                                            )
                                        }
                                        style={{
                                            backgroundColor: "#1C5C9A",
                                            color: "white",
                                            fontWeight: "bold",
                                            minHeight: "40px",
                                        }}
                                    >
                                        Pesan Jadwal
                                    </Button>
                                )}
                                {isStrictAccess && (
                                    <Button
                                        onClick={() =>
                                            goToCancelSchedule(
                                                selectedEvent.id,
                                                selectedEvent.extendedProps
                                                    .scheduleData
                                            )
                                        }
                                        style={{
                                            backgroundColor: "#1C5C9A",
                                            color: "white",
                                            fontWeight: "bold",
                                            minHeight: "40px",
                                        }}
                                    >
                                        Batalkan Jadwal
                                    </Button>
                                )}
                                {!isStrictAccess &&
                                    selectedEvent.extendedProps.scheduleData
                                        ?.pelanggan?.id !== 0 && (
                                        <Button
                                            onClick={() =>
                                                goToCancelSchedule(
                                                    selectedEvent.id,
                                                    selectedEvent.extendedProps
                                                        ?.scheduleData
                                                )
                                            }
                                            style={{
                                                backgroundColor: "#1C5C9A",
                                                color: "white",
                                                fontWeight: "bold",
                                                minHeight: "40px",
                                            }}
                                        >
                                            Batalkan Jadwal
                                        </Button>
                                    )}

                                {isStrictAccess && (
                                    <Button
                                        onClick={() =>
                                            goToRemoveSchedule(
                                                selectedEvent.id,
                                                selectedEvent.extendedProps
                                                    ?.scheduleData
                                            )
                                        }
                                        style={{
                                            backgroundColor: "#1C5C9A",
                                            color: "white",
                                            fontWeight: "bold",
                                            minHeight: "40px",
                                        }}
                                    >
                                        Hapus Jadwal
                                    </Button>
                                )}
                                {isStrictAccess &&
                                    !selectedEvent.extendedProps.tersedia && (
                                        <Button
                                            onClick={() =>
                                                goToCustomerDetail(
                                                    selectedEvent.extendedProps
                                                        .scheduleData?.pelanggan
                                                        ?.id,
                                                    selectedEvent.extendedProps
                                                        .scheduleData
                                                )
                                            }
                                            style={{
                                                backgroundColor: "#1C5C9A",
                                                color: "white",
                                                fontWeight: "bold",
                                                minHeight: "40px",
                                            }}
                                        >
                                            Detail Pelanggan
                                        </Button>
                                    )}
                                <Button
                                    onClick={() => setShowPopup(false)}
                                    style={{
                                        backgroundColor: "#E34A4A",
                                        color: "white",
                                        fontWeight: "bold",
                                        minHeight: "40px",
                                    }}
                                >
                                    Tutup
                                </Button>
                            </div>
                        </div>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
}
